import React, { Component } from "react";
import Banner from "../assets/images/banner.jpg";
import Right from "../assets/images/right.svg";
import DownArrow from "../assets/images/downarrow.svg";
//import { Link } from "react-router-dom";
import SideNavBar from "./Components/SideBar";

import Reach from "../assets/images/reach.png";
import Saas from "../assets/images/saas.png";
import Tour from "../assets/images/tour.png";
import Grc from "../assets/images/grc.png";

import Henchris from "../assets/images/henchris.png";
import DecBase from "../assets/images/decbase.png";

import { Formik, Form, Field, ErrorMessage } from "formik";

import { Link } from "react-scroll";

import * as Yup from "yup"; // for everything

const sgMail = require("@sendgrid/mail");

const SendMailSchema = Yup.object().shape({
  name: Yup.string().required("Required"),
  email: Yup.string().email().required("Required"),
  message: Yup.string().required("Required"),
});

export default class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      prevScrollPos: 0,
      visible: false,
      prevScrollPos: 0,
    };
  }

  handleScroll = () => {
    // find current scroll position
    const currentScrollPos = window.pageYOffset;
    const { prevScrollPos } = this.state;

    // set state based on location info (explained in more detail below)
    // this.setState({
    //   visible:
    //     (prevScrollPos > currentScrollPos &&
    //       prevScrollPos - currentScrollPos > 70) ||
    //     currentScrollPos < 10,
    // });

    this.setState({
      visible: window.scrollY > 100,
    });

    // set state to new scroll position
    this.setState({ prevScrollPos: currentScrollPos });
  };

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  render() {
    var styleName = "navbar navbar-expand-md";
    if (this.state.visible) {
      styleName = "navbar navbar-expand-lg active";
    }
    return (
      <div id="home">
        <div className="banner">
          <nav class={styleName}>
            <Link class="navbar-brand" href="#">
              AA
            </Link>
            <div class="collapse navbar-collapse" id="navbarSupportedContent">
              <ul class="navbar-nav ml-auto">
                <li class="nav-item">
                  <Link
                    class="nav-link"
                    to="home"
                    spy={true}
                    smooth={true}
                    duration={500}
                    offset={0}
                  >
                    Home
                  </Link>
                </li>
                <li class="nav-item">
                  <Link
                    class="nav-link"
                    to="about"
                    spy={true}
                    smooth={true}
                    duration={500}
                    offset={0}
                  >
                    About
                  </Link>
                </li>

                <li class="nav-item">
                  <Link
                    class="nav-link"
                    to="projects"
                    spy={true}
                    smooth={true}
                    duration={500}
                    offset={0}
                  >
                    Work
                  </Link>
                </li>

                <li class="nav-item">
                  <Link
                    class="nav-link"
                    to="contactme"
                    spy={true}
                    smooth={true}
                    duration={500}
                    offset={0}
                  >
                    Contact
                  </Link>
                </li>
              </ul>
            </div>
            <SideNavBar />
          </nav>

          <div className="inner-container">
            <h2>
              Hi, I'm <span className="lighttext">Adeyemo Adekunle.</span>
            </h2>
            <h2>I'm a full-stack web developer.</h2>
            <div
              className="d-flex justify-content-center mt-4"
              id="btn-wrapper"
            >
{/*               <button className="btn">
                <a target="_blank" href="https://www.fiverr.com/kunlexze">
                  Hire me on fiver
                </a>
              </button> */}
              <Link
                to="projects"
                spy={true}
                smooth={true}
                duration={500}
                offset={0}
              >
                <button className="btn">View my work</button>
              </Link>
            </div>
          </div>
        </div>

        <section id="about">
          <div className="mb-20">
            <h5>ABOUT ME</h5>
            <hr></hr>
          </div>

          <div className="row">
            <div className="col-md-6">
              <h6>Hello!</h6>
              <p>
                My name is Adeyemo Adekunle, i'm a full-stack software developer
                and i have serious passion for using technology to build amazing
                products and focusing on solving real world problems.
              </p>
              <p>
                I will love to hear from you. Whether it's a project, job,
                opportunity or just a chat. Feel free to contact me.
              </p>
            </div>
            <div className="col-md-6">
              <h6>Skills</h6>
              <div className="row">
                <div className="col-md-6">
                  <ul>
                    <li>HTML & (S)CSS</li>
                    <li>React Js</li>
                    <li>Spring Boot</li>
                  </ul>
                </div>
                <div className="col-md-6">
                  <ul>
                    <li>JavaScript (ES6+)</li>
                    <li>Node Js</li>
                    <li>Java EE (Liferay & Vaddin)</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section id="projects">
          <div className="mb-20">
            <h5 className="text-center">PROJECTS</h5>
            <hr></hr>
          </div>
          <div className="d-flex justify-content-center">
            <div className="item">
              <img src={Reach}></img>
              <div className="inner-container">
                <div className="title">Reach Bukka</div>
                <div className="title2">
                  Reach Bukka is a food ordering web app i created where people
                  can order food online and get it delivered to their door step.
                  Made using React Js and Firebase.
                </div>
                <button className="btn">
                  <a target="_blank" href="https://reachbukka.web.app">
                    View Live
                  </a>
                </button>
              </div>
            </div>
            <div className="item">
              <img src={Grc}></img>
              <div className="inner-container">
                <div className="title">GRC</div>
                <div className="title2">
                  I worked with a team of four developers that created a
                  Governance, Risk and Compliance application for Stanbic-IBTC
                  Pension Manager Ltd. This application enables SIPML Identify,
                  manage, monitor and analyse risk compliance across the
                  organization. Made using Liferay and Vaadin.
                </div>
                <button className="btn">
                  <a target="_blank" href="http://144.217.19.73:8080">
                    View Live
                  </a>
                </button>
              </div>
            </div>
          </div>

          <div className="d-flex justify-content-center">
            <div className="item">
              <img src={Henchris}></img>
              <div className="inner-container">
                <div className="title">Henchris CBT</div>
                <div className="title2">
                  Hencris CBT is a Computer based testing web application. Made
                  using Mongo db, Express, React Js and Node Js.
                </div>
                <button className="btn">
                  <a target="_blank" href="https://fierce-chamber-83283.herokuapp.com">
                    View Live
                  </a>
                </button>
              </div>
            </div>
            <div className="item">
              <img src={DecBase}></img>
              <div className="inner-container">
                <div className="title">React Js Landing Page</div>
                <div className="title2">
                  The Base is a landing page created for a furniture organization. Made
                  using React Js.
                </div>
                <button className="btn">
                  <a target="_blank" href="https://the-base-designs.web.app">
                    View Live
                  </a>
                </button>
              </div>
            </div>
          </div>

          <div className="d-flex justify-content-center">
            <div className="item">
              <img src={Saas}></img>
              <div className="inner-container">
                <div className="title">React Js Landing Page</div>
                <div className="title2">
                  Gritza Saas is a landing page i created for a
                  Software-as-a-Service, or SaaS for short company, that
                  provides cloud-based method software services to users. Made
                  using React Js.
                </div>
                <button className="btn">
                  <a target="_blank" href="https://gritzasass.web.app">
                    View Live
                  </a>
                </button>
              </div>
            </div>
            <div className="item">
              <img src={Tour}></img>
              <div className="inner-container">
                <div className="title">React Js Landing Page</div>
                <div className="title2">
                  Gritza Tours is a landing page i created where people can plan
                  their holiday or vacation trip. Made using React Js.
                </div>
                <button className="btn">
                  <a target="_blank" href="https://gritzatour.web.app">
                    View Live
                  </a>
                </button>
              </div>
            </div>
          </div>
        </section>

        <section id="contactme">
          <div className="header">CONTACT ME</div>
          <hr />
          <Formik
            initialValues={{ name: "", email: "", message: "" }}
            validationSchema={SendMailSchema}
            onSubmit={(values, { setSubmitting, setFieldError }) => {
              console.log("values", values);

              sgMail.setApiKey(
                "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"
              );
              const msg = {
                to: "adeyemokunlexze@gmail.com",
                from: values.email, // Use the email address or domain you verified above
                subject: "Portfolio " + values.name,
                text: values.message,
              };
              //ES6
              sgMail.send(msg).then(
                () => {},
                (error) => {
                  console.error(error);

                  if (error.response) {
                    console.error(error.response.body);
                  }
                  setSubmitting(false);
                }
              );
              //ES8
              (async () => {
                try {
                  await sgMail.send(msg);
                } catch (error) {
                  console.error(error);

                  if (error.response) {
                    console.error(error.response.body);
                  }
                  setSubmitting(false);
                }
              })();
            }}
          >
            {({ isSubmitting, errors }) => (
              <Form>
                {errors.error && <p className="form-error">{errors.error}</p>}
                <div class="form-group">
                  <Field
                    type="text"
                    class="form-control"
                    name="name"
                    placeholder="Fullname"
                  />
                  <ErrorMessage
                    name="name"
                    component="div"
                    className="form-error"
                  />
                </div>
                <div class="form-group">
                  <Field
                    name="email"
                    type="email"
                    class="form-control"
                    placeholder="Email"
                  />
                  <ErrorMessage
                    name="email"
                    component="div"
                    className="form-error"
                  />
                </div>
                <div class="form-group">
                  <Field
                    class="form-control"
                    placeholder="Message"
                    rows="3"
                    name="message"
                    component="textarea"
                  />
                  <ErrorMessage
                    name="message"
                    component="div"
                    className="form-error"
                  />
                </div>
                <button
                  type="submit"
                  class="btn btn-block special-btn"
                  disabled={isSubmitting}
                >
                  SEND MESSAGE
                </button>
              </Form>
            )}
          </Formik>
        </section>
      </div>
    );
  }
}
